module.exports = __webpack_public_path__ + "static/christoffer-engstrom-wc9avd2RaN0-unsplash-54d4c13a19c68cb52bce51077cf747e8.jpg";